<template>
    <footer class="footer__wrapper">
        <div class="rlms-container">
            <div class="group__section">
                <!-- Join Box -->
                <div></div>
                <div class="getintouch__box">
                    <div class="title__box__wrapper">
                        <h4 class="title">Join EESA Now</h4>
                        <div class="short__note">
                            <p>Please get in touch if you have any questions regarding the app or EESA in general!</p>
                        </div>
                    </div>
                    <div class="btn__wrap">
                        <div class="getintouch__btn">
                            <a href="https://datamakesthedifference.com/contact" target="_blank">Get In Touch</a>
                        </div>
                    </div>
                </div>

                <!-- Footer Main -->
                <div class="footer__box__wrapper">
                    <div class="footer__cover__box">

                        <!-- Logo -->
                        <div class="footer__logo__wrap">
                            <RouterLink to="/">
                                <img :src="logo" alt="EESAPP APP" />
                            </RouterLink>
                        </div>

                        <!-- Footer Links -->
                        <div class="footer__links__wrapper">
                            <div class="footer__links" v-for="(section, i) in linkSections" :key="i">
                                <h5 class="title">{{ section.title }}</h5>
                                <div class="footer__link__list">
                                    <ul>
                                        <li v-for="(link, j) in section.links" :key="j">
                                            <RouterLink
                                                :to="{ path: link.path ? link.path : $route.path, hash: `${link.href}` }">
                                                {{ link.label }}</RouterLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- Social Links -->
                        <div class="follow__us__on">
                            <h5 class="title">Follow Us On</h5>
                            <div class="social__media__links">
                                <ul>
                                    <li v-for="(icon, i) in socialLinks" :key="i">
                                        <a :href="icon.href" target="_blank" rel="noopener">
                                            <img :src="icon.icon" :alt="icon.alt" width="38"/>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div class="footer__sepline"></div>
                    <div class="all__rights">
                        <p>© 2025 All rights Reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
import logo from '@/assets/logo.png'
import facebook from '@/assets/images/facebook-icon.svg'
import linkedin from '@/assets/images/linkedin-icon.svg'
import twitter from '@/assets/images/twitter-x-icon.png'
import youtube from '@/assets/images/youtube-icon.svg'

const linkSections = [
    {
        title: 'Main Links',
        links: [
            { label: 'About EESA', href: '#about', path: '/' },
            { label: 'Dr. Barbara Esch', href: '#author', path: '/' },
            { label: 'Pricing', href: '', path: '/pricing' }
        ]
    },
    {
        title: 'Learner',
        links: [
            { label: 'Members', href: '', path: '/dashboard' },
            { label: 'Learners', href: '', path: '/dashboard' },
            { label: 'Assessment', href: '', path: '/dashboard' }
        ]
    },
    {
        title: 'Company',
        links: [
            { label: 'Privacy Policy', href: '', path: '/privacy-policy' },
            { label: 'Terms & Conditions', href: '', path: '/terms-conditions' },
        ]
    }
]

const socialLinks = [
    { href: 'https://www.facebook.com/datamtd/', icon: facebook, alt: 'facebook' },
    { href: 'https://www.linkedin.com/company/data-makes-the-difference-llc/', icon: linkedin, alt: 'linkedin' },
    { href: 'https://x.com/datamtd', icon: twitter, alt: 'twitter' },
    { href: 'https://www.youtube.com/@vbmappapp', icon: youtube, alt: 'youtube' }
]
</script>
